/* global TradeInValuations */
import React, { Component } from "react"
import PropTypes from "prop-types"

import ContactQualification from "./ContactQualification"
import TradeInThankYou from "./TradeInThankYou"
import BuyerIntentions from "./TradeInResult/BuyerIntentions"
import SendPicturesSms from "./SendPicturesSms"

class ContentBelowValuation extends Component {
  componentDidMount() {
    this.props.buyerIntentionHtml && TradeInValuations.initIntentionForm()
  }

  componentDidUpdate(prevProps, _prevState) {
    // When buyerIntentionHtml contents gets set, trigger the callback
    this.props.buyerIntentionHtml &&
      !prevProps.buyerIntentionHtml &&
      TradeInValuations.initIntentionForm()
  }

  render() {
    const {
      intentionSent,
      buyerIntentionHtml,
      contactQualificationSent,
      contactQualification,
      buyerIntentions,
      betaVersion,
      customerDisclaimer,
      displayValuation,
    } = this.props

    return (
      <React.Fragment>
        {(intentionSent && !buyerIntentions) ||
        contactQualificationSent ||
        // If neither features are active, show the thank you message
        (!buyerIntentionHtml &&
          !buyerIntentions &&
          !contactQualification &&
          !betaVersion) ? (
          <TradeInThankYou {...this.props} />
        ) : intentionSent && buyerIntentions ? (
          <React.Fragment>
            <TradeInThankYou {...this.props} />
            <SendPicturesSms
              {...this.props.sendPicturesSmsProps}
              trackFunction={this.props.trackFunction}
              betaVersion
              noEstimation={!this.props.displayValuation}
            />
          </React.Fragment>
        ) : contactQualification ? (
          <ContactQualification {...contactQualification} />
        ) : buyerIntentions && displayValuation ? (
          <BuyerIntentions
            {...buyerIntentions}
            source="result page"
            trackFunction={this.props.trackFunction}
          />
        ) : (
          buyerIntentionHtml &&
          displayValuation && (
            <div dangerouslySetInnerHTML={{ __html: buyerIntentionHtml }} />
          )
        )}
        {betaVersion && !buyerIntentions && (
          <SendPicturesSms
            {...this.props.sendPicturesSmsProps}
            trackFunction={this.props.trackFunction}
            betaVersion
            noEstimation={!this.props.displayValuation}
          />
        )}
        {betaVersion && displayValuation && (
          <React.Fragment>
            <p
              className="customer-disclaimer beta"
              dangerouslySetInnerHTML={{
                __html: customerDisclaimer,
              }}
            />
          </React.Fragment>
        )}
      </React.Fragment>
    )
  }
}

ContentBelowValuation.propTypes = {
  intentionSent: PropTypes.bool,
  buyerIntentionHtml: PropTypes.string,
  buyerIntentions: PropTypes.object,
  leadInfo: PropTypes.object,
  leadInfoTranslations: PropTypes.object,
  contactQualification: PropTypes.object,
  contactQualificationSent: PropTypes.bool,
  betaVersion: PropTypes.bool,
  customerDisclaimer: PropTypes.string,
  displayValuation: PropTypes.bool,
  sendPicturesSmsProps: PropTypes.object,
  trackFunction: PropTypes.func,
}

export default ContentBelowValuation
